// src/pages/CompletedPurchasesPage.js
import React, { useState, useEffect } from 'react';
import { formatDate } from '../utils/formatDate';
import './PurchasesPage.css';
import { API_URL } from "../config";

function CompletedPurchasesPage() {
    const [purchases, setPurchases] = useState([]);

    useEffect(() => {
        fetchCompletedPurchases();
    }, []);

    const fetchCompletedPurchases = async () => {
        try {
            const response = await fetch(`${API_URL}/purchases/completed`, {
                credentials: 'include',
            });
            if (!response.ok) throw new Error('Błąd pobierania zrealizowanych zamówień.');
            const data = await response.json();
            setPurchases(data);
        } catch (error) {
            console.error('Błąd:', error);
        }
    };

    return (
        <div className="purchases-page">
            <header className="purchases-header">
                <h2>Zamówienia Zrealizowane</h2>
            </header>
            <section className="purchases-grid">
                {purchases.length === 0 ? (
                    <p>Brak zrealizowanych zamówień.</p>
                ) : (
                    purchases.map(purchase => (
                        <div key={purchase.id} className="purchase-card">
                            <span className="purchase-number">#{purchase.nr_zamowienia}</span>
                            <p><strong>Nr Zlecenia:</strong> {purchase.nr_ref}</p>
                            <p><strong>Tytuł Zamówienia:</strong> {purchase.tytul_zamowienia}</p>
                            <p><strong>Osoba Zamawiająca:</strong> {purchase.first_name} {purchase.last_name}</p>
                            <p><strong>Data Zamówienia:</strong> {formatDate(purchase.data_utworzenia)}</p>
                            <p><strong>Termin Realizacji:</strong> {formatDate(purchase.termin_realizacji)}</p>
                            <p><strong>Status:</strong> {purchase.status}</p>
                        </div>
                    ))
                )}
            </section>
        </div>
    );
}

export default CompletedPurchasesPage;